import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { List } from 'immutable';
import {
    fetchReferCalendar,
    updateReferOpeningHours,
} from 'flow/actions/pbx-actions';
import CalendarBase from 'flow/components/calendar/CalendarBase';
import Loading from 'flow/components/ui-components/Loading';
import { ReferKey } from 'flow/types/EntityKeys';

import { getCalendarWithActiveProfileAddedToEvents } from 'flow/utils/calendar-utils';
import { sortProfilesAfterPlusId } from 'flow/utils/profile-utils';

const PbxIvrCalendar = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { entityKey } = useParams<{ entityKey: ReferKey }>();

    const profiles = useAppSelector((state) =>
        state.pbx.getIn(['refers', entityKey, 'profiles'], List()),
    );

    const activeProfile = useAppSelector((state) =>
        state.pbx.getIn(['refers', entityKey, 'activeProfile'], null),
    );

    const calendar = useAppSelector((state) =>
        state.pbx.getIn(['refers', entityKey, 'calendar']),
    );

    useEffect(() => {
        dispatch(fetchReferCalendar(entityKey));
    }, []);

    if (!calendar || !profiles) {
        return <Loading />;
    }

    return (
        <CalendarBase
            calendar={getCalendarWithActiveProfileAddedToEvents(
                activeProfile,
                calendar,
            )}
            entityKey={entityKey}
            profiles={sortProfilesAfterPlusId(profiles)}
            onClickBack={() =>
                history.push(
                    generatePath('pbx.refers.entityKey.profiles', {
                        entityKey,
                    }),
                )
            }
            updateOpeningHours={(openingHours) => {
                dispatch(updateReferOpeningHours(entityKey, openingHours));
            }}
        />
    );
};

export default PbxIvrCalendar;
